import { Icon } from "../Icon.jsx";
import { XAI_SCHOOL_LINKS } from "../../data/consultantCourse.js";

const orientationFacts = [
  ["13", "domande mirate"],
  ["0", "email o telefono"],
  ["Subito", "il livello consigliato"],
];

export function OrientationSection() {
  return (
    <section className="orientation-section page-section" id="orientamento" aria-labelledby="orientation-title">
      <div className="orientation-section__copy">
        <span className="section-kicker">Orientamento gratuito</span>
        <h2 id="orientation-title">Parti dal livello giusto per te.</h2>
        <p>
          Il test riconosce ciò che sai già fare e ti indirizza al percorso più utile,
          senza costringerti a ripartire dalle basi.
        </p>
        <a className="button button--coral" href={XAI_SCHOOL_LINKS.assessment}>
          Fai il test gratuito <Icon name="arrow" size={18} />
        </a>
      </div>
      <div className="orientation-facts" aria-label="Come funziona il test">
        {orientationFacts.map(([value, label]) => (
          <div key={label}><strong>{value}</strong><span>{label}</span></div>
        ))}
      </div>
    </section>
  );
}
